import React from "react";
import MarketIndicesDashboardClient from "./MarketIndicesClient";
import type {
  IndexListItem,
  IndicesInsightsConfig,
  ScripInfoData,
} from "./Interface";
import { getFilteredIndicesList } from "../../services/TradingMallService";
import { fetchIndicesScripInfo } from "./indicesinfo";

interface MarketIndicesDashboardProps {
  config?: IndicesInsightsConfig;
  isMobileApp?: boolean;
}

export const MarketIndicesDashboard: React.FC<
  MarketIndicesDashboardProps
> = async ({ config, isMobileApp = false }) => {
  const indicesList: IndexListItem[] = await getFilteredIndicesList();
  const initialIndices = indicesList.slice(0, 4);
  const initialDataEntries = await Promise.all(
    initialIndices.map(async (index) => {
      const data = await fetchIndicesScripInfo(index.token, index.exchange ?? 0);
      return [index.token, data] as const;
    }),
  );
  const initialDataByToken = Object.fromEntries(initialDataEntries) as Record<
    number,
    ScripInfoData | null
  >;
  const firstIndex = initialIndices[0];
  const initialData: ScripInfoData | null =
    (firstIndex ? initialDataByToken[firstIndex.token] : null) ?? null;

  // App header content offset is mt-[65px]; web sticky header is 112/108.
  const scrollMtClass = isMobileApp
    ? "scroll-mt-[65px]"
    : "scroll-mt-[112px] md:scroll-mt-[108px]";

  return (
    <section
      id="indices-insight"
      className={`${scrollMtClass} px-4 py-3 md:max-w-[864px]`}
    >
      <MarketIndicesDashboardClient
        indicesList={indicesList}
        config={config}
        initialIndexSymbol={firstIndex?.symbol ?? ""}
        initialData={initialData}
        initialDataByToken={initialDataByToken}
      />
    </section>
  );
};
